import { Button } from "@mui/material";
import ModalWaitList from "../ModalWaitList";
import { useState } from "react";
import { useSpecialities } from "../hooks/useSpecialities";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { dayDefaultAvailableState } from "src/SearchHours/components/calendars/state/atoms";
import { hourSelectedState } from "src/store/reservation/reservationState";
import {
  disabledSelectState,
  professionalWaitListState,
  showWaitListState,
  specialitiesWaitListState,
} from "../state/atoms";
import { filterSearchSelectedState } from "src/SearchHours/state/atoms";

export default function ButtonWaitList({ onClick, styles }) {
  const [open, setOpen] = useState(false);
  const setDisableSelect = useSetRecoilState(disabledSelectState);
  const resetProfessionalWaitList = useResetRecoilState(
    professionalWaitListState
  );
  const resetHourSelected = useResetRecoilState(hourSelectedState);

  const specialities = useRecoilValue(specialitiesWaitListState);

  const showWaitList = useRecoilValue(showWaitListState);

  const professionalFilter = useRecoilValue(filterSearchSelectedState);

  const handleOpenModal = () => {
    onClick && onClick();
    onClick && setDisableSelect(true);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setDisableSelect(false);
    resetProfessionalWaitList();
    resetHourSelected();
  };

  if (!showWaitList) return null;

  return (
    <div>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleOpenModal}
        style={{ ...styles }}
      >
        Lista de Espera
      </Button>
      <ModalWaitList open={open} onClose={handleCloseModal} />
    </div>
  );
}
